import Link from "next/link";
import { useTranslations } from "next-intl";
import { Button } from "@repo/ui/components/ui/button";
import Image from "next/image";

export default function Warranties() {
  const t = useTranslations("Home.warranties");
  const warrantiesKeys = ["card1", "card2", "card3"] as const;

  return (
    <section
      id="how-works"
      className="scroll-mt-[200px] max-md:scroll-mt-[100px] mt-[50px] max-md:mt-[20px] max-md:scroll-mt-[60px]"
    >
      <h3 className="text-center mb-[40px] max-md:mb-[20px] leading-none max-md:text-[30px]">
        {t("title")}
      </h3>
      <div className="grid grid-cols-3 gap-8 max-md:grid-cols-1">
        {warrantiesKeys.map((key) => (
          <div key={key} className="flex flex-col gap-[20px] items-center">
            <h4 className="md:h-[40px] text-[24px] font-normal">
              {t(`${key}.title`)}
            </h4>
            <div className="relative h-[60px] aspect-square">
              <Image
                src={t(`${key}.image`)}
                alt={t(`${key}.title`)}
                fill
                sizes="100vw"
                quality={100}
                style={{ objectFit: "fill", objectPosition: "center" }}
              />
            </div>
            <p className="text-center flex-1">
              {t.rich(`${key}.content`, {
                br: () => <br />,
              })}
            </p>
          </div>
        ))}
      </div>
      <div className="w-full flex justify-center">
        <Link href="/search">
          <Button className="my-[40px]" variant="default">
            {t("what_searching")}
          </Button>
        </Link>
      </div>
    </section>
  );
}
